// 核心样式
import "codemirror/lib/codemirror.css";
import "codemirror/lib/codemirror";
import "codemirror/mode/javascript/javascript.js";
import "codemirror/mode/css/css.js";
import "codemirror/mode/xml/xml.js";
import "codemirror/mode/clike/clike.js";
import "codemirror/mode/markdown/markdown.js";
import "codemirror/mode/python/python.js";
import "codemirror/mode/r/r.js";
import "codemirror/mode/shell/shell.js";
import "codemirror/mode/sql/sql.js";
import "codemirror/mode/swift/swift.js";
import "codemirror/mode/vue/vue.js";
import "codemirror/mode/htmlmixed/htmlmixed.js";

//下面这几个引入的主要是验证提示类的,配置里的lint需要设置true,gutters: ['CodeMirror-lint-markers']
import "codemirror/addon/lint/coffeescript-lint";
import "codemirror/addon/lint/css-lint";
// import "codemirror/addon/lint/html-lint.js";
import "codemirror/addon/lint/javascript-lint";
import "codemirror/addon/lint/json-lint";
import "codemirror/addon/lint/lint.css";
import "codemirror/addon/lint/lint";
import "codemirror/addon/lint/yaml-lint";

//及时自动更新，配置里面也需要设置autoRefresh为true
import "codemirror/addon/display/autorefresh";
import "codemirror/addon/display/fullscreen.css";
import "codemirror/addon/display/fullscreen";
import "codemirror/addon/display/panel";
import "codemirror/addon/display/placeholder";
import "codemirror/addon/display/rulers";
// 自动补全使用需要引入工具
import "codemirror/addon/hint/anyword-hint";
import "codemirror/addon/hint/css-hint";
import "codemirror/addon/hint/html-hint";
import "codemirror/addon/hint/javascript-hint";
import "codemirror/addon/hint/show-hint.css";
import "codemirror/addon/hint/show-hint"; //html自动补全
import "codemirror/addon/hint/sql-hint";
import "codemirror/addon/hint/xml-hint";
//  折叠
import "codemirror/addon/fold/brace-fold.js";
import "codemirror/addon/fold/comment-fold.js";
import "codemirror/addon/fold/foldcode.js";
import "codemirror/addon/fold/foldgutter.css";
import "codemirror/addon/fold/foldgutter.js";
import "codemirror/addon/fold/indent-fold.js";
import "codemirror/addon/fold/markdown-fold.js";
import "codemirror/addon/fold/xml-fold.js";

// 标签匹配
import "codemirror/addon/edit/closetag";
import "codemirror/addon/edit/closebrackets";
import "codemirror/addon/edit/matchtags";
import "codemirror/addon/edit/matchbrackets";
import "codemirror/addon/edit/continuelist";
// 主题
import "codemirror/theme/panda-syntax.css"; // 深色、 最好看的一种




// WEBPACK FOOTER //
// ./src/utils/option.js